import { Injectable } from '@angular/core';
import { CeiPersonalDataMenuItem } from '@cei-ufg/ngx-arquitetura-cei-frontend';

export const CEI_APPS_MENU_ALTERAR_VINCULO = 'alterar-vinculo';
export const CEI_APPS_MENU_DADOS_PESSOAIS = 'dados-pessoais';
export const CEI_APPS_MENU_SOBRE = 'sobre';
export const CEI_APPS_MENU_SAIR = 'sair';

@Injectable({ providedIn: 'root' })
export class PersonalDataMenuService {
  buildMenuItems(pessoaId?: number): CeiPersonalDataMenuItem[] {
    return [
      {
        label: 'Alterar vínculo',
        action: true,
        icon: 'link',
        value: CEI_APPS_MENU_ALTERAR_VINCULO,
      },
      {
        label: 'Dados Pessoais',
        action: true,
        icon: 'person',
        value: CEI_APPS_MENU_DADOS_PESSOAIS,
        url: '/pessoas/me/atualizar',
      },
      {
        label: 'Sobre',
        action: true,
        icon: 'info',
        value: CEI_APPS_MENU_SOBRE,
      },
      {
        label: 'Sair',
        action: true,
        icon: 'logout',
        value: CEI_APPS_MENU_SAIR,
      },
    ];
  }

  resolveItemAction(item: CeiPersonalDataMenuItem): string | undefined {
    if (typeof item.value === 'string') {
      return item.value;
    }

    return undefined;
  }
}
